// import router from "../router"
export const SVGMixin = {
  // for svg zoom in, move around, etc
  data() {
    return {

    };
  },
  methods: {

  },


}